// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23nuK","importantInfo":"styles_importantInfo__1Se1W"};